export default __webpack_public_path__ + "static/1003-54bfc2fec301e19c455ad6cb58ab73fa.gif";